import * as Yup from 'yup'


const sellerInventoryBatchPutAwayItemSchema = Yup.object().shape({
  location : Yup.object().required('Required'),
  skus     : Yup.array()
    .of(
      Yup.object().shape({
        sku: Yup.string().required('Required')
      })).unique('Setiap sku item harus unik', (skus) => skus.sku)
    .required('Required')
})

export default sellerInventoryBatchPutAwayItemSchema